export default {
  EMPTY: 0, // Belum Mengumpulkan Tugas
  PENDING: 1, // Sudah Mengumpulkan Tugas Namun Dalam Proses Penilaian
  SUCCESS: 2,
  FAILED: 3,
  PENDING_INTERNAL: 99 // Dalam Proses Antrian Pihak Kariermu
}
